export const environment = {
  firebase: {
    projectId: 'aguacate-wallet-qa',
    appId: '1:455461068324:web:703b6f15fa5312448ec2b1',
    storageBucket: 'aguacate-wallet-qa.appspot.com',
    apiKey: 'AIzaSyB532JuLd5JDhWc43qPlWPA-ZcXRuJflgc',
    authDomain: 'aguacate-wallet-qa.firebaseapp.com',
    messagingSenderId: '455461068324',
    measurementId: 'G-CMJ0LWH3C2',
    applicationServerKey:
      'BP4XiQR6lR20NC2R23Cj1MuvpurOVlF9AP7BOk7GXhHCXXMJQuhWt2Q6-k-ES9J2YvLPXdhVM1r8hrCQQRxXCSI',
  },
  production: false,
  apiGatewayURL: 'https://uridtvqqv6.execute-api.us-east-1.amazonaws.com/qa/',
  apiGatewayRetailUrl:
    'https://xgnjg1m32i.execute-api.us-east-1.amazonaws.com/qa/',
  cognito: {
    userPoolId: 'us-east-1_sBy62iRLx',
    userPoolWebClientId: '4u97pfvb2rc2k7r1k2cpjru32p',
    mandatorySignIn: false,
    region: 'us-east-1',
    identityPoolId: 'us-east-1:e88d2a0b-195f-4ad3-b44b-70bd63c94ec4',
  },
  // Solo metadatos públicos del bucket — el frontend NUNCA firma URLs.
  // Las pre-signed URLs vienen del backend (S3UrlService).
  s3: {
    bucket: 'aguacatewalletdata',
    region: 'us-east-1',
    identityPoolId: 'us-east-1:e88d2a0b-195f-4ad3-b44b-70bd63c94ec4',
  },
  apiNest: 'https://wallet-api-qa.aguacatewallet.com/',
  //apiNest: 'http://localhost:3000/',
  //apiKyc: 'http://localhost:3000/kyc/v1/',
  apiKyc: 'https://wfeafotix9.execute-api.us-east-1.amazonaws.com/dev/kyc/v1/',
  // Habilita el modulo binance-link para OPERADORES. Clientes nunca ven —
  // bloqueo por rol en el sidebar y guards. Kill-switch global si se pone false.
  binanceLinkEnabled: false,
  // Registro de empresas: flujo nuevo de 13 pasos dentro de dinamic-signup.
  //
  // `false` deja el comportamiento anterior: la empresa termina en el OTP de
  // WhatsApp (4 pasos) y sale al dashboard, donde el ActivateGuard la manda al
  // monolito `company-registration`. Es el kill-switch: apagarlo no deja
  // registros a medias, porque los pasos 5 a 13 no escriben nada que el
  // monolito no sepa reanudar.
  empresaSignupV2Enabled: true,
  // Muestra "Movimientos Vita" en el sidebar. En prod va en `false`: la ruta
  // sigue viva y se entra solo por URL.
  vitaMovimientosEnSidebar: true,
};
